import { call, put, select, takeEvery } from "redux-saga/effects";
import {
  FETCH_PREDICTIVE_ETA,
  FETCH_PREDICTIVE_ETA_FAILED,
  FETCH_PREDICTIVE_ETA_SUCCESS,
} from "../action/predictiveETA-action";
import { getPredictiveETA } from "../api/api";
import { predictiveETADRW } from "../api/drwApi";
import { getPredictiveETAInDRWFlag } from "../features/FeatureFlags/selectors";
import { datadogRum } from "@datadog/browser-rum";
import { PredictiveETAResponse } from "../types/PredictiveETAAddress";

export function* predictiveETASaga(action) {
  try {
    const payload = action?.payload || {};
    const { currentLocation, partnerCode, appId, source } = payload;
    const lat = currentLocation?.latitude;
    const lng = currentLocation?.longitude;
    const hasLat = lat != null && lat !== "" && Number(lat) !== 0;
    const hasLng = lng != null && lng !== "" && Number(lng) !== 0;

    if (!hasLat || !hasLng) {
      datadogRum.addError("Predictive ETA dispatched with missing lat/long", {
        source: source || "unknown",
        partnerCode,
        appId,
        hasCurrentLocation: !!currentLocation,
        hasLat,
        hasLng,
        hasZip: !!currentLocation?.zipCode,
        hasState: !!currentLocation?.state,
        latitude: lat,
        longitude: lng,
      });
    }

    const enablePredictiveETAInDRW: boolean = yield select(getPredictiveETAInDRWFlag);

    let response: PredictiveETAResponse;
    if (enablePredictiveETAInDRW) {
      response = yield call(predictiveETADRW, payload);
    } else {
      response = yield call(getPredictiveETA, payload);
    }

    yield put({ type: FETCH_PREDICTIVE_ETA_SUCCESS, payload: response });
  } catch (e) {
    datadogRum.addError(new Error(`Could not get Predictive ETA ${e}`), {
      source: action?.payload?.source || "unknown",
      partnerCode: action?.payload?.partnerCode,
      appId: action?.payload?.appId,
    });
    yield put({ type: FETCH_PREDICTIVE_ETA_FAILED });
  }
}

export function* watchPredictiveETASaga() {
  yield takeEvery(FETCH_PREDICTIVE_ETA, predictiveETASaga);
}